import axios from "axios";
import { BASE_URL } from "../../app/appConstants";

export const downloadFileFromBackend = (url: string, accessToken: string, download: boolean = false) => {

    axios
        .get(`${BASE_URL}${url}`, {
            headers: {
                Authorization: "Bearer " + accessToken,
                accept: "application/json"
            }
        })
        .then(response => {
            if (download) {
                window.open(response.data.downloadUrl, '_blank');
            } else {
                window.open(response.data.url, '_blank');
            }
        })
        .catch(error => {
            const { response } = error;
            return Promise.reject(response);
        });
};